import { INavigationConfig } from '~/src/dash/views/common';

export const biddersNavigationConfig: INavigationConfig = {
  tabs: [
    { key: 'All', label: 'All', value: 0, tKey: 'All' },
    { key: 'Groups', label: 'Groups', value: 1, tKey: 'Groups' },
    {
      key: 'Demand Source Settings',
      label: 'Demand Source Settings',
      value: 2,
      tKey: 'DemandSourceSettings',
    },
  ],
};
